export default {
  __name: 'PageHeader',
  setup(__props) {
    const handleSelect = () => {};
    return {
      __sfc: true,
      handleSelect
    };
  }
};